module.exports = __webpack_public_path__ + "static/media/toolBox.a545200f.svg";